// AUTO GENERATED FILE - Changes WILL be lost.
// hr - used as 'hr' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Listić za klađenje",
  "product.last60-row-single": "NBA 60 pojedinačna utakmica",
  "product.sb-english-single": "Engleski Soccerbet pojedinačna utakmica",
  "product.sb-italian-single": "Talijanski Soccerbet pojedinačna utakmica",
  "product.sb-greek-single": "Grčki Soccerbet pojedinačna utakmica",
  "product.sb-english-league": "Engleska nogometna liga",
  "product.sb-italian-league": "Talijanska nogometna liga",
  "product.sb-greek-league": "Grčka nogometna liga",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Stavite okladu",
  "betslip.clear": "Očistiti sve",
  "betslip.clearResult": "Čisto",
  "betslip.noSelections": "Dodajte odabire za početak klađenja",
  "betslip.notLoggedIn": "Prijavite se za početak klađenja",
  "betslip.refresh": "Osvježiti",
  "betslip.totalStake": "Ukupni ulog",
  "betslip.noHistoryData": "Nema dostupnih podataka o klađenju",
  "betslip.openBets": "Otvorene oklade",
  "betslip.betHistory": "Povijest klađenja",
  "betslip.betHistoryWon": "pobijedio",
  "betslip.betHistoryLost": "izgubljeno",
  "loading.loading": "Učitavam",
  "loading.account": "Učitavanje računa",
  "loading.league": "Učitavanje lige",
  "loading.gameweeks": "Učitavanje tjedana igre",
  "loading.markets": "Učitavanje tržišta",
  "loading.bethistory": "Učitavanje povijesti oklada",
  "login.loginRequired": "Potrebna prijava",
  "login.loginToBet": "Molimo prijavite se za početak klađenja",
  "navigation.back": "leđa",
  "navigation.close": "Zatvoriti",
  "video.liveStreamAvailable": "Dostupan prijenos uživo",
  "video.logInToWatch": "Molimo prijavite se za gledanje",
  "error.error": "Greška",
  "error.404": "Stranica nije pronađena",
  "error.gameLaunchFailed": "Nije moguće pokrenuti igru",
  "error.unknownErrorCode": "Nepoznata pogreška: {code}",
  "error.minUnitStakeLimitExceeded": "Minimalni ulog je {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksimalni ulog je {limit}",
  "error.minTotalStakeLimitExceeded": "Minimalni ukupni ulog je {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksimalni ukupni ulog je {limit}",
  "error.stakeInvalidMultiple": "Ulog mora biti višekratnik {multiple}",
  "error.notPlaced": "Nije postavljeno",
  "error.wagerDisallowed": "Oklada nije dopuštena",
  "error.errorEventIsOff": "Događaj je započeo",
  "wagerType.Singles": "Samci",
  "wagerType.Doubles": "Parovi",
  "wagerType.Trebles": "Trostruki",
  "wagerType.Accumulator": "Akumulator",
  "wagerType.Perm 4-Folds": "Trajna 4-nabora",
  "wagerType.Perm 5-Folds": "Trajna 5-nabora",
  "wagerType.Perm 6-Folds": "Trajna 6-nabora",
  "wagerType.Perm 7-Folds": "Trajna 7-nabora",
  "wagerType.Perm 8-Folds": "Trajna 8-nabora",
  "wagerType.Perm 9-Folds": "Trajna 9-nabora",
  "error.excess_bets": "Maksimalno {limit} istovremenih uloga na listiću za klađenje; molimo uklonite okladu",
  "product.sb-turkish-league": "Turska nogometna liga",
  "error.minBetslipLimitExceeded": "Minimalni ukupni ulog na listiću je {limit}",
  "error.maxBetslipLimitExceeded": "Maksimalni ukupni ulog na listiću je {limit}",
  "error.exceededMaxPayout": "Maksimalna potencijalna isplata je {limit}; molim vas smanjite svoj ulog.",
  "betslip.potentialReturns": "Potencijalni povrati",
  "betslip.taxDisclaimer": "Svi vaši neto dobici oporezuju se nakon podmirenja oklade. Iznos poreza će se izračunati ovisno o potencijalnom dobitku oklade.",
  "error.maintenanceEnabled": "Poslužitelj je trenutno u fazi održavanja",
  "error.internalError": "Interna pogreška",
  "error.invalidSession": "Sesija je nevažeća",
  "error.accountDisabled": "Račun je onemogućen",
  "error.invalidPlayerID": "Nevažeći ID igrača",
  "error.insufficientBalance": "Nedovoljna ravnoteža",
  "error.configError": "Greška u konfiguraciji",
  "error.betPlaceFailed": "Klađenje nije uspjelo",
  "error.invalidProductID": "Nevažeći ID proizvoda",
  "error.playerReachedGamingLimits": "Igrač je dosegao granice odgovornog igranja",
  "error.gameCycleDoesNotExist": "Ciklus igre ne postoji",
  "error.betAmountLimitExceeded": "Prekoračeno ograničenje potencijalne pobjede za neprovjerene igrače",
  "betslip.netStake": "Neto ulog",
  "betslip.tax": "Porez",
  "error.badReturns": "Potencijalni prinosi manji su od bruto uloga",
  "betslip.taxDisclaimerPoland": "Dobici će biti smanjeni za 10% za iznose veće od 2280 PLN.",
  "error.incompatibleVersion": "Nepodržana verzija aplikacije. Molimo nadogradite.",
  "product.iihf-row-single": "IIHF Svjetsko prvenstvo",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Povratak igraču",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Prosječni RTP za ovu igru je {limit}",
  "error.betslipContainsInvalidOptions": "Kladioničarski listić sadrži nevažeće opcije označene crvenom bojom",
  "product.sb-scottish-single": "Škotski Soccerbet Pojedinačna utakmica",
  "product.sb-spanish-single": "Španjolski Soccerbet pojedinačna utakmica",
  "product.sb-spanish-league": "Španjolska nogometna liga",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palača",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "Zapadna šunka",
  "sb-english.team.WOL": "Vukovi",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATENA",
  "sb-greek.team.APS": "APOLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS SOLUN",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALUN",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milano",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genova",
  "sb-italian.team.INT": "Između",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Nema više oklada",
  "playtime": "Vrijeme za igru",
  "gameId": "ID igre",
  "noGames": "Nema dostupnih igara. Pogledaj ponovo uskoro.",
  "Home": "Dom",
  "Away": "Daleko",
  "Visitor": "Posjetitelj",
  "rules": "Pravila",
  "soccerbet.gameWeek": "TJEDAN IGRE",
  "soccerbet.noGameWeeks": "Nema dostupnih tjedana igre. Pogledaj ponovo uskoro.",
  "soccerbet.league": "Poredak lige",
  "soccerbet.table.name": "Ime",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "BTTS",
  "event.Both Teams To Score": "Obje ekipe daju gol",
  "event.Over / Under": "Više/Ispod",
  "event.Double Chance": "Dupla šansa",
  "event.Match Result": "Rezultat utakmice",
  "event.Exact Goals": "Točni ciljevi",
  "event.Correct Score": "Točan rezultat",
  "event.Match Result Both Score": "Rezultat utakmice i obje ekipe postižu pogodak",
  "event.Result Und/Over 1.5 Total Goals": "Rezultat utakmice i više/manje od 1,5 ukupnih golova",
  "event.Result Und/Over 2.5 Total Goals": "Rezultat utakmice i više/manje od 2,5 ukupnih golova",
  "event.Under Over 1.5 Total Goals": "Više/ispod 1,5 ukupnih golova",
  "event.Under Over 2.5 Total Goals": "Više/ispod 2,5 ukupnih golova",
  "event.Under Over 3.5 Total Goals": "Više/ispod 3,5 ukupnih golova",
  "event.Under Over 4.5 Total Goals": "Više/ispod 4,5 ukupnih golova",
  "event.Total Goals 1 To 2": "Ukupno golova 1 do 2",
  "event.Total Goals 1 To 3": "Ukupno golova od 1 do 3",
  "event.Total Goals 1 To 4": "Ukupno golova od 1 do 4",
  "event.Total Goals 2 To 3": "Ukupno golova 2 do 3",
  "event.Total Goals 2 To 4": "Ukupno golova 2 do 4",
  "event.Under Over 1.5 Home Goals": "Više/ispod 1,5 golova domaće momčadi",
  "event.Under Over 1.5 Away Goals": "Više/ispod 1,5 golova gostujuće momčadi",
  "event.Home Team Exact Goals": "Domaći tim Točni golovi",
  "event.Away Team Exact Goals": "Točni golovi u gostima",
  "selection.Yes": "Da",
  "selection.No": "Ne",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Da",
  "selection.1+No": "1+br",
  "selection.X+Yes": "X+Da",
  "selection.X+No": "X+br",
  "selection.2+Yes": "2+Da",
  "selection.2+No": "2+br",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "x",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "NAD",
  "selection.Under": "POD, ISPOD",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NOVI",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NI",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALIJASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "OGLAS. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NE",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atletico Madrid",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Cadiz",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mallorca",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilla",
  "sb-spanish.team.VAL": "Valencia",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "LUD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "keltski",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "srca",
  "sb-scottish.team.HIB": "hiberijski",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rendžeri",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE",
  "iihf-row.team.CAN": "Kanada",
  "iihf-row.team.FIN": "Finska",
  "iihf-row.team.RUS": "Rusija",
  "iihf-row.team.USA": "Sjedinjene Države",
  "iihf-row.team.CZE": "Češka",
  "iihf-row.team.SWE": "Švedska",
  "iihf-row.team.SVK": "Slovačka",
  "iihf-row.team.NOR": "Norveška",
  "iihf-row.team.DEN": "Danska",
  "abbr.iihf-row.team.CAN": "KONZERVA",
  "abbr.iihf-row.team.FIN": "PERAJA",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "SAD",
  "abbr.iihf-row.team.CZE": "CZE",
  "abbr.iihf-row.team.SWE": "SWE",
  "abbr.iihf-row.team.SVK": "SRK",
  "abbr.iihf-row.team.NOR": "NITI",
  "abbr.iihf-row.team.DEN": "JAZBINA",
  "event.Icematchresnt": "Rezultat utakmice (1X2) (Regularno vrijeme)",
  "event.Icematchresot": "Rezultat utakmice (1,2) (uključujući produžetke)",
  "event.Icebothteamstoscore": "Obje momčadi postižu pogodak (regularno vrijeme)",
  "event.Icecorrectscoreot": "Točan rezultat (uključujući produžetke)",
  "event.Iceexactgoalsot": "Točni golovi (uključujući produžetke)",
  "event.Icegamelines2nt": "Linije za igru 2-smjerne (regulacijsko vrijeme)",
  "event.Icegamelines3nt": "Linije za igru 3-smjerno (regulacijsko vrijeme)",
  "event.Iceou2p5totalgoalsot": "Više od 2.5 ukupnih golova (uključujući produžetke)",
  "event.Iceou3p5totalgoalsot": "Više od 3.5 ukupnih golova (uključujući produžetke)",
  "event.Iceou4p5totalgoalsot": "Više od 4.5 ukupnih golova (uključujući produžetke)",
  "event.Iceteamaexactgoalsot": "Točni golovi domaće momčadi (uključujući produžetke)",
  "event.Iceteambexactgoalsot": "Točni golovi gostujuće momčadi (uključujući produžetke)",
  "event.Icematchresou3p5totalgoalsnt": "Rezultat utakmice i više/manje od 3.5 golova (regularno vrijeme)",
  "event.Icematchresou3p5totalgoalsot": "Rezultat utakmice i više/manje od 3.5 golova (uključujući produžetke)",
  "event.Icehighestscoreperiodnt": "Linije s najvećim brojem bodova (regularno vrijeme)",
  "event.Iceou25goalsteamateambot": "Više/manje od 2.5 golova momčadi kod kuće ili u gostima (uključujući produžetke)",
  "event.Icefirstteamtoscore": "Koja će momčad prva zabiti? (uključujući prekovremeni rad)",
  "event.Iceteamtowinmostperiods": "Momčad koja je pobijedila u najvećem broju trećina (regularno vrijeme)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3.5",
  "selection.A -3.0": "{home} -3.0",
  "selection.A -2.5": "{home} -2.5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1.5",
  "selection.A -1.0": "{home} -1.0",
  "selection.A +1.0": "{home} +1.0",
  "selection.A +1.5": "{home} +1.5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2.5",
  "selection.A +3.0": "{home} +3.0",
  "selection.A +3.5": "{home} +3.5",
  "selection.B -3.5": "{away} -3.5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2.5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1.5",
  "selection.B -1.0": "{away} -1.0",
  "selection.B +1.0": "{away} +1.0",
  "selection.B +1.5": "{away} +1.5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2.5",
  "selection.B +3.0": "{away} +3.0",
  "selection.B +3.5": "{away} +3.5",
  "selection.X -3.0": "X -3.0",
  "selection.X -2.0": "X -2.0",
  "selection.X -1.0": "X -1.0",
  "selection.X +1.0": "X +1,0",
  "selection.X +2.0": "X +2.0",
  "selection.X +3.0": "X +3,0",
  "selection.A & Over": "{home} i više",
  "selection.A & Under": "{home} & Ispod",
  "selection.X & Over": "X i više",
  "selection.X & Under": "X i ispod",
  "selection.B & Over": "{away} & Over",
  "selection.B & Under": "{away} & Under",
  "selection.A Over": "{home} Preko",
  "selection.A Under": "{home} Pod",
  "selection.B Over": "{away} Preko",
  "selection.B Under": "{away} Pod"
}
